import useTranslate from 'app/i18n/useTranslate';

const useConstants = () => {
    const t = useTranslate('mobileDrawerMenuButton');

    return {
        CLOSE_SIDEBAR: t('closeSidebar'),
        HOME: t('home'),
        ORG: t('org')
    };
};

export default useConstants;
